import {
  SCModalButton,
  SCModalButtonsContainer,
  SCModalContent,
  SCModalDescription,
  SCModalOverlay,
  SCModalTitle,
} from 'components/AugmentedReality/Structure/ConfirmModal/styled'
import React from 'react'

interface CameraInfoProps {
  title: React.ReactNode;
  description: string|React.ReactNode;
  onConfirm?: () => void;
  onCancel: () => void;
  labelConfirm: string;
  labelCancel: string;
}
const ConfirmModal = ({ title, description, onConfirm, onCancel, labelConfirm, labelCancel }: CameraInfoProps) => {
  return (
    <SCModalOverlay>
      <SCModalContent onClick={(e) => e.stopPropagation()}>
        <div>
          <SCModalTitle>{title}</SCModalTitle>
          <SCModalDescription>{description}</SCModalDescription>
        </div>
        <SCModalButtonsContainer>
          {!!onCancel && (
            <SCModalButton onClick={onCancel} $outlined>
              {labelCancel}
            </SCModalButton>
          )}
          {!!onConfirm && <SCModalButton onClick={onConfirm}>{labelConfirm}</SCModalButton>}
        </SCModalButtonsContainer>
      </SCModalContent>
    </SCModalOverlay>
  )
}

export default ConfirmModal;